module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table id="daily-votes-table" class="table table-sm table-striped">\n  <thead>\n    <tr>\n      <th>Legislation</th>\n      <th class="d-none d-sm-table-cell">Action</th> <!-- hide on xs devices -->\n      <th>Branch</th>\n      <th class="text-end">Yea</th>\n      <th class="text-end">Nay</th>\n      <th class="text-end">Excused</th>\n      <th class="text-end">Not Voting</th>\n    </tr>\n  </thead>\n  <tbody id="daily-votes"></tbody>\n</table>\n';
}
return __p;
};
